import { Box, GridItem, SimpleGrid, useDisclosure } from '@chakra-ui/react';
import Navbar from './navbar.component';
import Sidebar from './sidebar.component';

const Layout = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  const pathname = window.location.pathname;

  const isFlowFullscreen =
    pathname.startsWith('/flow/edit/') || pathname === '/flow/create-new';

  if (isFlowFullscreen) {
    return (
      <Box height="100vh" width="100vw" overflow="hidden" p={0} m={0}>
        {children}
      </Box>
    );
  }

  return (
    <Box height="100vh" overflow="hidden">
      <SimpleGrid columns={12} height="100%">
        <GridItem
          borderRight="1px solid"
          borderColor="gray.200"
          colSpan={isOpen ? 2 : 1}
          height="100%"
        >
          <Sidebar isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
        </GridItem>
        <GridItem colSpan={isOpen ? 10 : 11} height="100%" overflow="hidden">
          <Navbar isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
          <Box height="calc(100% - 64px)" overflow="auto" p={4}>
            {children}
          </Box>
        </GridItem>
      </SimpleGrid>
    </Box>
  );
};

export default Layout;
